module.exports = __webpack_public_path__ + "img/card-img-6.ac967c50.jpg";